export default __webpack_public_path__ + "static/media/sheeps.0cb8c16d.png";